module.exports = __webpack_public_path__ + "static/media/undo-alt.07a7b201.svg";